<div class="container" style="width: 60%;">
  <H1>Import Box</H1>

  <div *ngIf=StageOne>

    <div class="form-group">
      <label>Provider:</label>
      <div class="input-group mb-3">
        <select class="form-control" name="Provider" type="text" [(ngModel)]="Provider" required
          placeholder="Enter Provider">
          <option *ngFor="let Provider of ProvidersData; let i =index" value={{i}}>{{Provider.ID}}
          </option>
        </select>
      </div>
    </div>


    <div class="form-group">
      <label>Branch:</label>
      <div class="input-group mb-3">
        <select class="form-control" name="Branch" type="text" [(ngModel)]="Branch" required placeholder="Enter Branch">
          <option *ngFor="let Branch of Branchs; let i =index" value={{Branch}}>{{Branch}}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <label>Date received:</label>
      <div class="input-group mb-3">
        <input class="form-control" name="date" type="date" [(ngModel)]="date" required placeholder="Select a date"
          max={{CurrentDate}} />
      </div>
    </div>


    <div class="form-group" *ngIf="date && Branch">
      <label>Import Excel Spread Sheet:</label>
      <div class="input-group mb-3" style="justify-content: center;">
        <input type="file" (change)="onFileChange($event)" [(ngModel)]="excelFile" placeholder="Upload file"
          accept=".xls">
      </div>
    </div>

    <div class="form-group  form-button-div">
      <div style="float: left;margin-right: 20px;margin-left:20px;">
        <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="Reset()">Reset</button>
      </div>

      <div style="float: right;margin-left:20px;">
        <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!Branch || !date || !ImportValid"
          (click)="Next()">Next</button>
      </div>

    </div>



  </div>


  <div *ngIf=!StageOne style="min-width: 400px;">



    <table class="viewDataTable" ngb-sort>
      <tr>
        <th class="viewDataTableHeading">Box NUMBER</th>
        <th class="viewDataTableHeading">SERIAL NUMBER</th>
        <th class="viewDataTableHeading">BRICK NUMBER</th>
      </tr>

      <tr *ngFor="let dataDisplay of DataDisplay| paginate: { itemsPerPage: ItemsPerPage, currentPage: p }">
        <td class="viewDataTableCell">{{dataDisplay.BoxNum}}</td>
        <td class="viewDataTableCell">{{dataDisplay.SerialNum}}</td>

        <td class="viewDataTableCell">{{dataDisplay.BrickNumber}}</td>
      </tr>

    </table>

    <pagination-controls (pageChange)="p = $event"></pagination-controls>

    <div class="form-group  form-button-div">

      <div style="float: left;margin-right: 20px;">
        <button class="btn btn-primary btn-lg btn-block" type="submit" (click)="Back()">Back</button>
      </div>

      <div style="float: right;margin-left:20px;">
        <button class="btn btn-success btn-lg btn-block" type="submit" (click)="Done()"
          [disabled]='DataDisplay.length<=0'>Confirm</button>
      </div>

    </div>

  </div>

</div>



<!--Error popup-->
<div style="float: right;margin-left:20px;">
  <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
  </button>
</div>
<ng-template #content let-modal ID="Errormessage">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{PopupTitle}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

      <span aria-hidden="true">
        ×
      </span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="dateOfBirth">
          {{DisplayErrormessage}}
        </label>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
      Done
    </button>
  </div>
</ng-template>